import { backgroundColor, textSize, titleFont, color, zIndex } from 'styles'

const previewExpiredStyles = {
  overlay: {
    position: 'fixed',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    ...zIndex('previewExpired'),
    ...backgroundColor('textDefault'),

  },
  text: {
    position: 'relative',
    top: '48%',
    ...titleFont(),
    ...textSize(25, 30),
    ...color('textSecondary'),
    textAlign: 'center'
  }
}

export default previewExpiredStyles
